export const destroyMediaStream = (mediaStream) => {
  mediaStream.getTracks().forEach((track) => track.stop());
};
